import { Grid } from '@material-ui/core';
import { darkBlue } from 'src/styles/colors';
import styled from 'styled-components';
import { mediaMaxWidth2 } from 'src/styles/layout';

const breakpointStyles = `
  display: none;
`;

export const CoverSection = styled(Grid)`
  color: ${darkBlue};
  background-size: cover;
  height: 250px;
  ${mediaMaxWidth2.mobile`${breakpointStyles}`}
`;

export const Item = styled(Grid)`
  padding: 8px;
`;

const breakpointWrapperStyles = `
  margin-top: 150px;
`;

export const CoverWrapper = styled.div`
  ${mediaMaxWidth2.mobile`${breakpointWrapperStyles}`}
`;

const breakpointMandatesStyles = `
  margin-top: 50px;
`;

export const MandatesCoverWrapper = styled.div`
  ${mediaMaxWidth2.mobile`${breakpointMandatesStyles}`}
`;
